import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class PasswordService {
    constructor() {}

    generatePass(): string | null {
        const options =
            'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890';
        const passSplit = [];
        let password: string;

        for (let i = 0; i < 9; i++) {
            passSplit.push(
                options[Math.ceil(Math.random() * options.length - 1)]
            );
        }

        password = passSplit.join('');

        if (
            this.hasLowerCase(password) &&
            this.hasNumber(password) &&
            this.hasUpperCase(password)
        ) {
            return password;
        } else {
            return null;
        }
    }

    hasLowerCase(password: string) {
        const lowerCase = 'abcdefghijclmñopqrstuvwxyz';
        let has = false;

        lowerCase.split('').forEach(letter => {
            if (password.includes(letter)) {
                has = true;
            }
        });

        return has;
    }

    hasNumber(password: string) {
        const numbers = '1234567890';
        let has = false;

        numbers.split('').forEach(number => {
            if (password.includes(number)) {
                has = true;
            }
        });

        return has;
    }

    hasUpperCase(password: string) {
        const upperCase = 'ABCDEFGHIJCLMÑOPQRSTUVWXYZ';
        let has = false;

        upperCase.split('').forEach(letter => {
            if (password.includes(letter)) {
                has = true;
            }
        });

        return has;
    }

    hasSpecialChars(password: string) {
        const specialChars = '!"#€$%&()*+,-./:;<=>?@[^]_`{|}~';
        let has = false;

        specialChars.split('').forEach(letter => {
            if (password.includes(letter)) {
                has = true;
            }
        });

        return has;
    }
}
